import axios from 'axios'

export const newPayment = (payId, product) => {
    return axios.post('/v2/pay', {payId, product})
}

export const newToken = (token) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};